export default "__VITE_ASSET__DOxVoh5w__"